import { Typography } from '@material-ui/core'
import React from 'react'

const FAKE_CLIENTS_NUMBER: Array<number> = [10, 15, 12, 14, 9]

interface ActiveClients{
  trainerId: string;
}

const getFakeClientsNumber = (trainerId:string) => {
  const localStorageKey = `active_clients_number:${trainerId}`
  const priceFromStorage = localStorage.getItem(localStorageKey)
  if(priceFromStorage){
    return Number(priceFromStorage)
  }
  const fakeClientsNumber = FAKE_CLIENTS_NUMBER[Math.floor(Math.random() * FAKE_CLIENTS_NUMBER.length)];
  localStorage.setItem(localStorageKey, `${fakeClientsNumber}`);
  return fakeClientsNumber
}

export const ActiveClients:React.FC<ActiveClients> = ({trainerId}) => {
  const [fakeClientsNumber, setFakeClientsNumber] = React.useState<number>()

  React.useEffect(() => {
    setFakeClientsNumber(getFakeClientsNumber(trainerId))
  }, [])

  return (
    <Typography >{`${fakeClientsNumber} Active Clients`}</Typography>
  )
}